import { GraphQLCall, validatedResponse } from "./helper";
import { getCareTeamListOfPartnerListQuery } from "./graphQl/queries";
import { registerCareTeamMember, updateCareTeamUserMutation } from "./graphQl/mutations";

export const getGQLCareTeamList = async () => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const data = await GraphQLCall(
            getCareTeamListOfPartnerListQuery,
            { limit: 100, offset: 0, partnerId: user?.orgId, }
        );

        const validatedData = validatedResponse("getCareTeamListOfPartner", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const saveNewCareTeamUser = async (variables) => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));

        const data = await GraphQLCall(registerCareTeamMember, {
            ...variables,
            partnerId: user?.orgId,
        });

        const validatedData = validatedResponse("saveCareTeamUser", data);
        return validatedData;
    } catch (error) {
        console.error("Error while saving new user:", error.message);
        throw error;
    }
};

export const saveExistingCareTeamUser = async (variables) => {
    try {
        const data = await GraphQLCall(updateCareTeamUserMutation, {
            ...variables,
        });

        const validatedData = validatedResponse("updateCareTeamUser", data);
        return validatedData;
    } catch (error) {
        console.error("Error while saving new user:", error.message);
        throw error;
    }
};
